import React from "react";
import { Box } from "@mui/material";
import Steps from "./Steps";
import ReadyToPartner from "./ReadyToPartner";
import PartnershipForm from "./PartnershipForm";
import ImpactMetrics from "./ImpactMetrics/index";
import Footer from "../About/Footer";
import PartnershipFAQ from "./Partnershipfaq/index";

export default function PartnerWithUsNew() {
  return (
    <>
    <Box
      sx={{
        backgroundColor: "#fff",
        width: "100%", 
        boxSizing: "border-box", 
        p: { xs: 0.5, sm: 1, md: 2 },
      }}
    >
      <PartnershipForm />
      <Steps />
      <ImpactMetrics />
      <ReadyToPartner />
      <PartnershipFAQ />
    </Box>
    <Footer />
    </>
  );
}